// Lib
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementOnReachHistoryConfig = {
    title: 'chart.instagram.avg_engagement_on_reach_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.avg_engagement_on_reach_history_name'
    },
    id: 'average_engagement_on_reach_history',
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    tooltip: 'chart.instagram.tooltip_avg_engagement_on_reach_history',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
